export class TasacionModel {
    id: number;
    codigoTasacion: string;
    entidadFinancieraId: number;
    referenciaBanco: string;
    referenciaBanco2: string;
    fechaPedido: Date;
    fechaPresupuesto: Date; //Nullable
    //cliente:object;
    clienteId: number;
    clienteSolicitanteId: number; //Nullable
    clienteSolicitanteDescr: string;
    clienteDescr: string;
    solicitanteLibre: string;
    nPresupuesto: string;
    estadosFacturacionId: number; //Nullable
    distrito: string;
    concejo: string;
    barrio: string;
    provincia: string;
    localidad: string;
    freguesia: string;
    direccion: string;
    piso: string;
    puerta: string;
    codPostal: string;
    pais: string;
    tipoInmuebleId: string;
    finalidadId: number;
    contratoId: number;
    descripcion: number;
    responsableID: number; //Nullable
    tasadorId: number; //Nullable
    visitadorId: number; //Nullable
    validadorId: number; //Nullable
    estadoId: number; //Nullable
    fechaAsignacionTecnico: Date; //Nullable
    fechaIntento: Date; //Nullable
    visitaComentario: string;
    resultadoVisita: number; //Nullable
    fechaInformeEnviado: Date; //Nullable
    fechaInformeValidado: Date; //Nullable
    valorTasacion: number; //Nullable
    haSidoValidado: boolean;
    fechaInformeEntregadoCliente: Date; //Nullable
    haSidoEntregado: boolean;
    importeFacturable: number;
    importeEditable: boolean;
    estadoIncidencia: string;
    descripcionLarga: string;
    comentariosInternos: string;
    contacto_NombreCompleto: string;
    contacto_Telefono: string;
    contacto_Email: string;
    facturable: boolean; //Nullable
    salesPersonCode: string;
    textoFactura: string;
    visita: boolean;
    long: number; //Nullable
    lat: number; //Nullable
    fechaFacturado: Date;
    tipoTasacion: boolean; //Nullable
    version: number; //Nullable
    canalEntradaId: number; //Nullable
    oficinaFacturacionId: number; //Nullable
    prescriptorId: number; //Nullable
    importeFacturado: number;
    createdDate: Date;
    deadline: Date;
    categorizacionABC: string;
    importePresupuestado: number;
    provision: string;
    importeProvision: number;
    liqTecnicaAcordada: number;
    liqTecnicaAcordada_Importe: number;
    liqTecnicaAcordada_Porcentaje: number;
    estadoPrevioId: number;
    tiempoConsumido: string;
    isDuplicada: boolean;



    public constructor() {
        this.id = null;
        this.codigoTasacion = null;
        this.entidadFinancieraId = null;
        this.referenciaBanco = null;
        this.referenciaBanco2 = null;
        this.fechaPedido = null;
        this.fechaPresupuesto = null;
        //this.cliente = null;
        this.clienteId = null;
        this.clienteSolicitanteId = null;
        this.clienteSolicitanteDescr = null;
        this.clienteDescr = null;
        this.solicitanteLibre = null;
        this.nPresupuesto = null;
        this.estadosFacturacionId = null;
        this.distrito = null;
        this.concejo = null;
        this.barrio = null;
        this.provincia = null;
        this.localidad = null;
        this.freguesia = null;
        this.direccion = null;
        this.piso = null;
        this.puerta = null;
        this.codPostal = null;
        this.pais = null;
        this.tipoInmuebleId = null;
        this.finalidadId = null;
        this.contratoId = null;
        this.descripcion = null;
        this.responsableID = null;
        this.tasadorId = null;
        this.visitadorId = null;
        this.validadorId = null;
        this.estadoId = null;
        this.fechaAsignacionTecnico = null;
        this.fechaIntento = null;
        this.visitaComentario = null;
        this.resultadoVisita = null;
        this.fechaInformeEnviado = null;
        this.fechaInformeValidado = null;
        this.valorTasacion = null;
        this.haSidoValidado = null;
        this.fechaInformeEntregadoCliente = null;
        this.haSidoEntregado = null;
        this.importeFacturable = null;
        this.importeEditable = null;
        this.estadoIncidencia = null;
        this.descripcionLarga = null;
        this.comentariosInternos = null;
        this.contacto_NombreCompleto = null;
        this.contacto_Telefono = null;
        this.contacto_Email = null;
        this.facturable = null;
        this.salesPersonCode = null;
        this.textoFactura = null;
        this.visita = null;
        this.long = null;
        this.lat = null;
        this.fechaFacturado = null;
        this.tipoTasacion = null;
        this.version = null;
        this.canalEntradaId = null;
        this.oficinaFacturacionId = null;
        this.createdDate = null;
        this.prescriptorId = null;
        this.importeFacturado = null;
        this.deadline = null;
        this.categorizacionABC = null;
        this.importePresupuestado = null;
        this.provision = null;
        this.importeProvision = null;
        this.liqTecnicaAcordada = ValoresLiquidacionTecnicaAcordada.SinDefinir;
        this.liqTecnicaAcordada_Importe = 0;
        this.liqTecnicaAcordada_Porcentaje = 0;
        this.estadoPrevioId = null;
        this.tiempoConsumido = "";
        this.isDuplicada = false;
    }
}

// export const ValoresLiquidacionTecnicaAcordada = {
//     0: 'Sin definir',
//     1: 'Importe',
//     2: 'Porcentaje',
//     3: 'Sin Liquidacion',
// };

export enum ValoresLiquidacionTecnicaAcordada {
    SinDefinir = 0,
    Importe = 1,
    Porcentaje = 2,
    SinLiquidacion = 3
}

export enum ValoresEstadoTasacion {
    TramitacionAlta = 100,
    EnCurso = 400,
    EnIncidencia = 700,
    InformeEnviado = 800,
    InformeValidado = 900,
    InformeEntregado = 910,
    ReclamacionCliente = 1200,
    Anulado = 1300
}